export function basenameWithoutExtension(path: string): string {
  const i = Math.max(path.lastIndexOf("/"), path.lastIndexOf("\\"));
  if (i >= 0) {
    path = path.substring(i + 1);
  }
  const j = path.lastIndexOf(".");
  return j > 0 ? path.substring(0, j) : path;
}
